var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icons)?_c('div',_vm._l((_vm.icons),function(icon){return _c('marker-button',{key:icon.id,attrs:{"marker":icon}})}),1):_c('div',[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }